<template>
  <SwitchGroup>
    <div class="flex items-center">
      <SwitchLabel v-if="$slots.before" class="mr-4">
        <slot name="before"></slot>
      </SwitchLabel>
      <Switch
        v-model="model"
        :class="model ? 'bg-lexmea-pop' : 'bg-slate-300'"
        class="relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
      >
        <span class="sr-only">
          <slot name="label"></slot>
        </span>
        <span
          :class="model ? 'translate-x-6' : 'translate-x-1'"
          class="inline-block h-4 w-4 transform rounded-full bg-white transition duration-200 ease-in-out"
        />
      </Switch>
      <SwitchLabel v-if="$slots.after" class="ml-4">
        <slot name="after"></slot>
      </SwitchLabel>
    </div>
  </SwitchGroup>
</template>

<script lang="ts" setup>
interface Props {
  modelValue?: boolean;
}

type Emits = {
  "update:modelValue": [value: boolean];
};

const props = withDefaults(defineProps<Props>(), { modelValue: false });

const emit = defineEmits<Emits>();

const model = useVModel(props, "modelValue", emit);
</script>
